/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Settings_Office_Legal_NameInputs */

const cs_settings_office_legal_name = /** @type {(inputs: Settings_Office_Legal_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Název firmy`)
};

const en_settings_office_legal_name = /** @type {(inputs: Settings_Office_Legal_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Company name`)
};

/**
* | output |
* | --- |
* | "Company name" |
*
* @param {Settings_Office_Legal_NameInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const settings_office_legal_name = /** @type {((inputs?: Settings_Office_Legal_NameInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Office_Legal_NameInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_settings_office_legal_name(inputs)
	return cs_settings_office_legal_name(inputs)
});